export default __webpack_public_path__ + "static/media/shape.36635dbe.svg";